import axios from "axios";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { env } from "../../env";
import Swal from "sweetalert2";
import CameraCaptureComponent from "./CameraCaptureComponent";

const AttachmentPopUp = ({customerId, categoryList, sendAttachmentPopUpDataFromChild}) => {
    const { t } = useTranslation();

    const [showDropDown, setShowCategoryList] = useState(false);
    const [showChooseModal, setShowChooseModal] = useState(false);
    const [showOpenCamera, setShowOpenCamera] = useState(false);
    const [dragOver, setDragOver] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);

    const [file, setFile] = useState("");
    const [fileName, setFileName] = useState("");
    const [fileSize, setFileSize] = useState(0);
    const [category, setCategory] = useState("");
    const [categoryId, setCategoryId] = useState("");
    const [error, setError] = useState('');

    const handleDragOver = (event) => {
        event.preventDefault();
        setDragOver(true);
    };
    const handleDragLeave = () => {
        setDragOver(false);
    };
    const handleDrop = (event) => {
        event.preventDefault();
        setError("");
        setDragOver(false);
        
        const droppedFiles = event.dataTransfer.files[0];
        if (droppedFiles) {
            const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg', 'application/msword'];
            const maxSize = 10 * 1024 * 1024; // 10MB in bytes
            
            // Check file type
            if (!allowedTypes.includes(droppedFiles.type)) {
                setError('Invalid file format. Allowed formats are .pdf, .png, .jpg, .jpeg, .doc');
                setFile(null);
                setFileName('');
                setFileSize(0);
                return;
            }
    
            // Check file size
            if (droppedFiles.size > maxSize) {
                setError('File size exceeds 10MB');
                setFile(null);
                setFileName('');
                setFileSize(0);
                return;
            }
    
            // Convert the file to Base64
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(',')[1]; // Remove data URL prefix
                setFile(base64String);  // Store Base64 string
                setFileName(droppedFiles.name);  // Store file name
                setFileSize(droppedFiles.size);  // Store file size
            };
            
            reader.readAsDataURL(droppedFiles); // Read the dropped file as a data URL
        }
    };
    const handleFileInputChange = (event) => {
        setError("");
        const selectedFile = event.target.files[0];
        
        if (selectedFile) {
            const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg', 'application/msword'];
            const maxSize = 10 * 1024 * 1024; // 10MB in bytes
            
            // Check file type
            if (!allowedTypes.includes(selectedFile.type)) {
                setError('Invalid file format. Allowed formats are .pdf, .png, .jpg, .jpeg, .doc');
                setFile(null);
                setFileName('');
                setFileSize(0);
                return;
            }
    
            // Check file size
            if (selectedFile.size > maxSize) {
                setError('File size exceeds 10MB');
                setFile(null);
                setFileName('');
                setFileSize(0);
                return;
            }
    
            // Convert the file to Base64
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(',')[1]; // Remove data URL prefix
                setFile(base64String);  // Store Base64 string
                setFileName(selectedFile.name);  // Store file name
                setFileSize(selectedFile.size);  // Store file size
            };
            
            reader.readAsDataURL(selectedFile); // Read the file as a data URL
        }
    };
    const handleDropDown = (event, value) => {
        event.preventDefault();
        setShowCategoryList(false);
        setCategory(value.Category);
        setCategoryId(value.Id);
    };
    const hangleModalClose = (e) => {
        e.preventDefault();
        sendAttachmentPopUpDataFromChild("normal");
        setFile("");
        setCategory("");
    };
    const handleCameraCloseDataFromChild = (data) => {
        setShowOpenCamera(data)
    };
    const handleImageDataFromChild = (data) => {
        setError("");
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = reader.result.split(',')[1];
            setFile(base64String);
            setFileName(data.name);
            setFileSize(data.size);
        };
        
        reader.readAsDataURL(data);
        setShowOpenCamera(false);
        setShowChooseModal(false);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        Swal.fire({
            title: `${ t("are you sure")}?`,
            text: `${ t("you want to add new attachment")}!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) { 
                setButtonLoading(true);
                const formData = new FormData();
                formData.append('image1', file);
                formData.append('CustomerId', customerId);
                formData.append('CategoryTypeId', categoryId);
                formData.append('filename', fileName);
    
                const baseUrl = env.REACT_APP_API_URL;
                const token = localStorage.getItem('token');
                axios.post(baseUrl + "/api/OfflineSync/InsertCustomerAttachments", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": `Bearer ${token}`
                    }
                }).then((response) => {
                    if (response.data.success === true) {
                        sendAttachmentPopUpDataFromChild('updated');
                    } else{
                        setButtonLoading(false);
                    }
                }).catch((error) => {
                    console.log(error);
                    setButtonLoading(false);
                    if (error.response && (error.response.status === 401 || error.response.status === 404)) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("userInfo");
                        window.location.reload();
                    }
                });
            }
        });
    };
    
    return (
        <form onSubmit={(e) => handleSubmit(e)}>
            <div className="fixed z-40 overflow-y-auto top-0 w-full left-0 h-full">
                <div className="flex items-center justify-center min-height-100vh px-4 py-8 text-center sm:block sm:p-0 h-full">
                    <div className="fixed inset-0 transition-opacity">
                        <div className="absolute inset-0 bg-gray-900 opacity-75" />
                    </div>
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                    <div className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-lg w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <div className="bg-white py-4 px-4 sm:px-8 sm:py-8 space-y-2 sm:space-y-3">
                            <div className="flex justify-between">
                                <div className="font-semibold sm:text-lg capitalize">{ t('select category & add document')}</div>
                                <div className="cursor-pointer" onClick={(e) => (!buttonLoading && hangleModalClose(e))}>
                                    <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                                </div>
                            </div>
                            <div className="sm:flex sm:items-center text-sm space-y-1 sm:space-y-0">
                                <div className="sm:border sm:border-y-2 sm:border-l-2 sm:border-background-normal sm:p-2 sm:bg-blue-light capitalize sm:rounded-l-lg sm:w-52 sm:text-center">{ t('type of category')}</div>
                                <div className="relative border border-l-2 sm:border-l-0 border-y-2 border-r-2 border-background-normal p-2 w-full rounded-l-lg sm:rounded-l-none rounded-r-lg">
                                    <button type="button" onClick={(e) => setShowCategoryList(!showDropDown)} className=" text-gray-dark w-full justify-between font-normal inline-flex items-center">
                                        <span className={(category ? "text-black" : "text-gray-dark") + " capitalize mr-1 text-sm"}>{category.length > 0 ? t(category) : t('select')}</span>
                                        <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                    </button>
                                    {
                                        showDropDown
                                        ? 
                                            <ul className="absolute z-30 bg-white shadow-md rounded-md top-10 right-0 w-full">
                                                {categoryList && categoryList.map((category, index) => (
                                                    <li key={`category${index}`} onClick={(e) => handleDropDown((e), category)}  className="bg-white hover:bg-action-hover py-1 sm:py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-sm">{category.Category}</li>
                                                ))}
                                            </ul>                            
                                        : null
                                    }
                                </div>
                            </div>
                            <div onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} className={(file ? "hidden sm:block" : "hidden sm:flex flex-col justify-center items-center h-44") + " rounded-lg border-gray-normal border border-dashed cursor-pointer p-4"}>
                                <label htmlFor="dropzone-file" >
                                    {file
                                        ?   
                                            <div className="flex justify-between items-center">
                                                <div className="flex items-center space-x-2 text-sm">
                                                    <img className="w-6 h-6" src="../../assets/icons/profile/upload_file.svg" alt="upload_file" />
                                                    <div>{fileName}</div>
                                                    <div className="w-1 h-1 rounded-full bg-gray-dark4"></div>
                                                    <div className="text-gray-dark4 font-medium">{(fileSize  / 1024 / 1024).toFixed(2)} MB</div>
                                                </div>
                                                <div>
                                                    <img onClick={(e) => {setFile(""); setFileName(""); setFileSize(0);}} className="cursor-pointer w-6 h-6" src="../../assets/icons/profile/trash.svg" alt="trash" />
                                                </div>
                                            </div>
                                            
                                        :
                                            <div className="flex items-center space-x-2 cursor-pointer">
                                                <img src="../../assets/icons/profile/plus.svg" alt="plus" />
                                                <div className="font-medium first-letter:capitalize">{ t('drop files to upload or choose file')}</div>
                                            </div>
                                    }
                                    <input id="dropzone-file" type="file" value="" className="hidden" onChange={handleFileInputChange}  />
                                </label>
                            </div>
                            <div onClick={(e) => setShowChooseModal(!showChooseModal)} className={(file ? "block sm:hidden" : "flex sm:hidden flex-col justify-center items-center h-44") + " rounded-lg border-gray-normal border border-dashed cursor-pointer p-4"}>
                                {file
                                    ?   
                                        <div className="flex justify-between items-center">
                                            <div className="flex items-center space-x-2 text-sm">
                                                <img className="w-6 h-6" src="../../assets/icons/profile/upload_file.svg" alt="upload_file" />
                                                <div>{fileName}</div>
                                                <div className="w-1 h-1 rounded-full bg-gray-dark4"></div>
                                                <div className="text-gray-dark4 font-medium">{Math.round((fileSize  / 1024))} MB</div>
                                            </div>
                                            <div>
                                                <img onClick={(e) => {setFile(""); setFileName(""); setFileSize(0);}} className="cursor-pointer w-6 h-6" src="../../assets/icons/profile/trash.svg" alt="trash" />
                                            </div>
                                        </div>
                                        
                                    :
                                        <div className="flex items-center space-x-2 cursor-pointer">
                                            <img src="../../assets/icons/profile/plus.svg" alt="plus" />
                                            <div className="font-medium capitalize">{ t('upload or take photo')}</div>
                                        </div>
                                }
                            </div>
                            {error && <p className="text-red-normal text-sm font-semibold">{error}</p>}
                            {
                                showChooseModal ?
                                    <div className="flex justify-between">
                                        <button onClick={(e) => setShowOpenCamera(!showOpenCamera)} type="button" className="capitalize text-white bg-blue-normal border-blue-normal text-center px-4 text-xs font-mediu py-2 border rounded-lg tracking-wide">{t('take photo')}</button>
                                        <label className="capitalize text-white bg-blue-normal border-blue-normal text-center px-4 text-xs font-mediu py-2 border rounded-lg tracking-wide">{t('upload photo')}
                                            <input id="dropzone-file" type="file" value="" className="hidden" onChange={handleFileInputChange}  />
                                        </label>
                                    </div>
                                : null
                            }
                            { showOpenCamera ? <CameraCaptureComponent sendCameraCloseDataFromChild={handleCameraCloseDataFromChild} sendImageDataFromChild={handleImageDataFromChild} /> : null }
                            <div className="flex justify-end items-center space-x-4 mt-4 sm:mt-0">
                                <button onClick={(e) => (!buttonLoading && hangleModalClose(e))} type="button" className="text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 text-light-400 bg-white border border-light-400 rounded-lg tracking-wide capitalize">{ t('close') }</button>
                                <button type={category && file ? (buttonLoading ? "button" : "submit") : "button"} className={((category && file) ? ((buttonLoading ? "cursor-wait" : "cursor-pointer") + " text-white bg-blue-normal border-blue-normal") : "text-white border-blue-disable cursor-not-allowed bg-blue-disable" ) + " text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 border rounded-lg tracking-wide capitalize"}>{buttonLoading ? (t('Please wait')+'...') : t('confirm') }</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default AttachmentPopUp;